import{f as a}from"./createTheme-c3f66f95.js";var r="$$material";var e=a();export{r as T,e as d};
